export default __webpack_public_path__ + "static/media/018-rolling pin.d6fe23ef.svg";